export default {
    supplierName: "Nome da loja",
    mainCategory: "Categoria empresarial",
    contactName: "Nome de contato",
    contactPhoneNumber: "Número de telefone de contato",
    warehouseAddr: "Endereço do armazém",
    setPassword: "Configurar senha",
    confirmPassword: "Confirmar palavra-passe",
    legalPersonsname: "Nome de Pessoas Jurídicas",
    legalPersonPhoneNumber: "Número de telefone de pessoa jurídica",
    legalPersonsIDCard: "Bilhete de Identidade de Pessoas Colectivas",
    IDPhoto: "Foto de identificação",
    whetherThreeCertificatesAreInOne: "Se três certificados estão em um",
    unifiedSocialCreditCode: "Código Unificado de Crédito Social",
    operatingPeriod: "Período Operacional",
    businessLicense: "Alvará de funcionamento",
    long: "Longo"
}